import Loadable from 'react/components/loadable';

const CancelEvent = Loadable({
  loader: () => import('../../../react/pages/events/cancel_event/cancel_event'),
});

angular.module('gym').value('CancelEvent', CancelEvent);
